import createHistory from 'history/createBrowserHistory'
import thunkMiddleware from 'redux-thunk'
import { applyMiddleware, combineReducers, createStore } from 'redux'
import { routerMiddleware, routerReducer } from 'react-router-redux'
import { reducer as formReducer } from 'redux-form'
import { createLogger } from 'redux-logger'

import apiMiddleware from '../middleware/api'
import authReducer from '../reducers/auth'
import usersReducer from '../reducers/users'
import qrsReducer from '../reducers/qrs'
import qrsbaqueiraReducer from '../reducers/qrsbaqueira'
import qrsrentalReducer from '../reducers/qrsrental'
import openingsReducer from '../reducers/openings'
import calendarsReducer from '../reducers/calendars'
import qrstimeReducer from '../reducers/qrstime'

import { AUTH_LOGOUT } from '../actions/auth'
import { setActiveCurrency } from '../utils/currency'

export const history = createHistory()

const myRouterMiddleware = routerMiddleware(history)
const loggerMiddleware = createLogger()

const appReducer = combineReducers({
  auth: authReducer,
  qrs: qrsReducer,
  qrsbaqueira: qrsbaqueiraReducer,
  qrsrental: qrsrentalReducer,
  qrstime: qrstimeReducer,
  users: usersReducer,
  openings: openingsReducer,
  calendars: calendarsReducer,
  form: formReducer,
  router: routerReducer
}) 

const rootReducer = (state, action) => {
  if (action.type === AUTH_LOGOUT) {
    state = undefined
  }

  return appReducer(state, action)
};

const middleware = process.env.NODE_ENV === 'production' ?
  applyMiddleware(
    thunkMiddleware,
    apiMiddleware,
    myRouterMiddleware
  ) :
  applyMiddleware(
    thunkMiddleware,
    apiMiddleware,
    myRouterMiddleware,
    loggerMiddleware
  )

export const store = createStore(rootReducer, middleware);

// Divisa mostrada en todo el proceso QR = divisa de la pasarela del cliente
// (PaymentCurrency resuelta por el API en GET /qrs/token/:token, nunca la del
// contrato, EUR por defecto). Se fija al arrancar (qrData de localStorage) y
// cada vez que cambia el QR cargado; App.js remonta las vistas al cambiar.
const syncCurrency = () => {
  const qr = store.getState().qrs && store.getState().qrs.qr
  setActiveCurrency(qr && qr.PaymentCurrency)
}
syncCurrency()
store.subscribe(syncCurrency)
